import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { CostCenter } from 'InstitutionalManagement/types'
import CostCenterCard from 'InstitutionalManagement/components/CostCenterCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getCostCenterOnCustomForm from './services/getCostCenterOnCustomForm'

export default function CustomFormAnswerCostCenter() {
  const [loadingCostCenter, setLoadingCostCenter] = useState<boolean>(false)
  const [costCenter, setCostCenter] = useState<CostCenter>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const costCenterId: string = answerValue

  async function getCostCenter() {
    setLoadingCostCenter(true)
    const response = await getCostCenterOnCustomForm({ costCenterId })
    if (response?.header?.success) {
      const costCenterFromAPI = response?.body?.cost_center
      setCostCenter(costCenterFromAPI)
    }
    setLoadingCostCenter(false)
  }

  useEffect(() => {
    if (answerValue) getCostCenter()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingCostCenter}>
      <CostCenterCard borderWidth="1px" borderColor="borderColor" costCenter={costCenter} />
    </Skeleton>
  )
}
